/* tslint:disable */
 
import { Icon } from './icon';
import { LocalizedValue } from './localized-value';
import { NullableLocalizedValue } from './nullable-localized-value';

/**
 * (tsType: Omit<DataRelation, >, schemaOptions: { includeRelations: undefined, exclude: [] })
 */
export class DataRelation {
  dataEntity: string;
  description?: null | NullableLocalizedValue;
  icon: null | Icon;
  id?: string;
  isImplicit?: boolean;
  name: LocalizedValue;
  normalizedName?: string;
  relationType: 0 | 1;
  specificationVersion: number;
  targetEntity: string;
  targetField: string;
}
